// Check if this is a private instance or not
export const PRIVATE_AI_INSTANCE =
  process.env.NEXT_PUBLIC_PRIVATE_AI_INSTANCE === "true" ? true : false;

export const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL
  ? process.env.NEXT_PUBLIC_BACKEND_URL
  : "http://localhost:8000";

export const INSTANCE_NAME = process.env.NEXT_PUBLIC_INSTANCE_NAME || "general";

// OAuth providers enabled for this instance (comma-separated: "google,azure")
export const OAUTH_PROVIDERS: string[] = (
  process.env.NEXT_PUBLIC_OAUTH_PROVIDERS || ""
)
  .split(",")
  .map((p) => p.trim().toLowerCase())
  .filter(Boolean);
